export interface ReviewRow {
  id: string;
  kind?: string;
  proposalId?: string;
}

export function reviewTarget(rows: ReviewRow[], id: string): { proposalId: string; quotationId: string } | null {
  const hit = rows.find((row) => row.id === id);
  if (!hit) return null;
  if (hit.kind === 'quotation') return { proposalId: hit.proposalId || '', quotationId: hit.id };
  const quotation = rows.find((row) => row.kind === 'quotation' && row.proposalId === hit.id);
  return { proposalId: hit.id, quotationId: quotation?.id || '' };
}
